import i18n from './instance';
import { saveStoredLang, type AppLang, isAppLang } from './locale';

export async function changeAppLanguage(lang: AppLang): Promise<void> {
  if (!isAppLang(lang)) return;
  saveStoredLang(lang);
  await i18n.changeLanguage(lang);
}
